import { render } from "./UEInternationalEditView.vue?vue&type=template&id=0ebaf210&scoped=true"
import script from "./UEInternationalEditView.vue?vue&type=script&lang=js"
export * from "./UEInternationalEditView.vue?vue&type=script&lang=js"

import "./UEInternationalEditView.vue?vue&type=style&index=0&id=0ebaf210&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebaf210"]])

export default __exports__